//import { init } from "../../../components/Lit/acc-boot/acc-boot.js";
import { init } from "../../../components/Lit/acc-boot/acc-boot";
import { Markets } from "../../../components/Lit/acc-es-data/model";
import { RootState, store } from "../../../store";
import { fetchConfig } from "../../../common/util/config";
import { BootType, setBoot, BootUser } from "../../boot";
import { updateContentPathForMarket } from "../../../i18n.config";
import { NavDropdown } from "../../../common/interfaces/routing";
import { ShellConfigApiResponse } from "../../../services/MyBizShell/mybizShellAPI.types";
import { LoginFields, setloginLocalStorage } from "../../loginLocalStorage";

export interface ShellConfig extends ShellConfigApiResponse {
  showLogoutLink?: boolean;
  menuConfig: NavDropdown[];
}

export const getAuthHeader = ({ boot }: Pick<RootState, "boot">) => {
  const { user } = boot;
  const { token_type = "", access_token } = user;
  const tokenType = `${token_type.charAt(0).toUpperCase()}${token_type.slice(1)}`;

  return {
    authorization: `${tokenType} ${access_token}`,
  };
};

export const getLoginAffAbo = ({ boot }: Pick<RootState, "boot">) => {
  const { user } = boot || {};
  const { aff, abo } = user || {};
  return `${aff}-${abo}`;
};

export const initAccBoot = async (bootSettings: BootType) => {
  const loc = store.getState().loginLocalStorage.loginFields.locale;
  const selectedPeriod = store.getState().period.selectedPeriod;
  const accBootSettings = {
    oauth: {
      // We parse the #scope parameter directly within the MasheryReceiver.tsx,
      // and store the token and boot data in session storage.
      // Setting this to false prevents acc-boot from attempting to parse the parameter again.
      parse: false,
    },
    setup: {
      globalStore: true,
      globalName: "accBoot",
    },
    api: {
      config: bootSettings.configuration,
    },
    locale: {
      languageCode: loc || bootSettings.configuration.defaultLocale,
      market: bootSettings.user.isoCountryCode,
      isoCurrencyCode: bootSettings.configuration.defaultCurrencyCode,
      path: `/content/${bootSettings.user.isoCountryCode}/text/`,
    },
    user: bootSettings.user,
    businessInView: bootSettings.user,
    tokens: bootSettings.tokens,
    externalLinks: bootSettings.configuration.dashboardLinks,
    userManual: bootSettings.configuration.userManual,
    bonusPeriod: selectedPeriod,
  };
  return init(accBootSettings);
};

export const SetBootForCurrentBusiness = async ({
  user,
  isImpersonation,
}: {
  user: Partial<BootUser>;
  isImpersonation?: boolean;
}) => {
  const { loginFields } = store.getState().loginLocalStorage;
  const storedSsoOrigin = loginFields.ssoOrigin;

  // we need to check if the initial market logged in is using the new NextGen configs
  // and the selected business we are switching to is from that same market.
  // If so, use the `storedSsoOrigin` as this will have the `NG` suffix i.e: `TH_NG`
  const isNextGen =
    storedSsoOrigin &&
    storedSsoOrigin.length > 2 &&
    storedSsoOrigin.includes("_NG") &&
    storedSsoOrigin.substring(0, 2) === user.isoCountryCode;

  const ssoOrigin = isNextGen ? storedSsoOrigin : user.isoCountryCode;

  const config = await fetchConfig(`/configs/${ssoOrigin}.configuration.json`);

  let { aff, isoCountryCode } = user;

  if (!aff && isoCountryCode) {
    aff = new Markets().getByIso(isoCountryCode).aff;
  }

  if (store.getState().boot.user.isoCountryCode !== user.isoCountryCode) {
    updateContentPathForMarket(user.isoCountryCode);
  }

  await store.dispatch(
    setBoot({
      isImpersonation: isImpersonation ?? loginFields.isImpersonation,
      configuration: config,
      user: { ...user, aff },
    }),
  );

  return await store.getState().boot;
};

export const SetLoginFields = async ({ fields }: { fields: Partial<LoginFields> }) => {
  await store.dispatch(
    setloginLocalStorage({
      loginFields: { ...fields },
    }),
  );

  return await store.getState().loginLocalStorage;
};
